import { axiosInstance } from './axiosInstance'

export const defaultFetcher = <Response>(url: string): Promise<Response> =>
  axiosInstance
    .get<Response>(url, {
      headers: {
        Accept: 'application/json',
      },
    })
    .then((res) => res.data)

export function postFetcher<Response>(url: string): Promise<Response> {
  return axiosInstance
    .post<Response>(url, null, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    })
    .then((res) => res.data)
}
